import { useEffect, useLayoutEffect } from "react";

const useScrollRestoration = ({ scrollRef, childRef, pathname, behavior = "instant" }) => {
  if (behavior !== "instant" && behavior !== "smooth") {
    throw new Error(`behavior needs to be 'instant' or 'smooth' and it is currently ${behavior}`);
  }

  useEffect(() => {
    const scrollElement = scrollRef.current;
    const handleScroll = () => {
      const position = childRef.current.getBoundingClientRect().top - 64;
      updateScrollPosition(pathname, position);
    };

    const onScroll = () => debounce(handleScroll, 100);

    scrollElement.addEventListener("scroll", onScroll);

    return () => {
      scrollElement.removeEventListener("scroll", onScroll);
    };
  }, [scrollRef, childRef, pathname]);

  useLayoutEffect(() => {
    const scrollPosition = Math.abs(getScrollPosition(location.pathname) || 0);
    scrollRef.current.scrollTo({
      top: Math.abs(scrollPosition),
      left: 0,
      behavior,
    });
  }, [scrollRef, behavior]);
};

function getPositionMap() {
  const positionMap = {};

  if (localStorage.getItem("scrollPositionMap")) {
    try {
      Object.assign(positionMap, JSON.parse(localStorage.getItem("scrollPositionMap")));
    } catch (_) {
      /* empty */
    }
  }

  return positionMap;
}

/**
 * Update scroll position for key
 * @param key{string}
 * @param position{number}
 */
function updateScrollPosition(key, position) {
  const positionMap = getPositionMap();
  positionMap[key] = position;
  localStorage.setItem("scrollPositionMap", JSON.stringify(positionMap));
}

/**
 * Get scroll position for key
 * @param key{string}
 * @returns {number|null}
 */
function getScrollPosition(key) {
  // Disable except homepage
  if (location.pathname.length > 1) {
    return 0;
  }

  const positionMap = getPositionMap();

  if (Object.hasOwn(positionMap, key) && positionMap[key]) {
    return positionMap[key];
  }

  return null;
}

function debounce(method, delay) {
  clearTimeout(method._tId);
  method._tId = setTimeout(() => {
    method();
  }, delay);
}

export default useScrollRestoration;
